import { MultiSearch } from "../common/SearchControls/GlobalSearch/typings";
import GlobalSearch from "../common/SearchControls/GlobalSearch/GlobalSearch";

export function getGlobalSearchControl(): GlobalSearch {
	return $find("GlobalSearch") as GlobalSearch;
}

export function executeSearch(): void {
	const control = getGlobalSearchControl();
	const searchParams = control.getSearchParams();
	const sideControlValue = control.getSideItemsSelectedValue();

	if (sideControlValue === MultiSearch.EDS) {
		mainNavigateContent(RFE.MultiSearch + "?sb=" + searchParams);
		return;
	}

	let url = RFE.SearchPage + "?";
	let query = "q=true";
	query += "&sb=" + searchParams;

	url += query;

	mainNavigateContent(url);
}

export function doAdvancedSearchClick(): void {
	const control = getGlobalSearchControl();
	const sideControlValue = control.getSideItemsSelectedValue();

	if (sideControlValue === MultiSearch.EDS) {
		const searchParams = control.getSearchParams();
		const method = RFE.ContentSearchMethod.Advanced;

		mainNavigateContent(RFE.MultiSearch + "?method=" + method + "&sb=" + searchParams);
	} else {
		const url = RFE.SearchPage + "?m=a";
		mainNavigateContent(url);
	}
}

export function showSearchTips(): void {
	const globalSearchControl = getGlobalSearchControl();
	const url = $.iframe.topWindow().getSearchTipsUrl(globalSearchControl);

	MLPanel.load(url);
}

export function globalSearchSideItemChanged(value: string): void {
	const control =  getGlobalSearchControl();
	const searchBlocks = control.getSearchBlocks();
	const searchParams = control.getSearchParams();

	if (searchBlocks && searchBlocks.length > 0) {
		if (value == "CCC") {
			mainNavigateContent("order/OrderSearch.aspx?q=true&sb=" + searchParams);
		} else {
			mainNavigateContent("order/MultiSearch.aspx?sb=" + searchParams);
		}
	}
}
